export function initOilfinderRedirect() {
    const typeId = new URLSearchParams(window.location.search).get('recommendation');
    if (!typeId) return;

    const iframe = document.querySelector('iframe[src*="lubricantadvisor.com"]');
    if (!iframe) return;

    const currentSrc = new URL(iframe.src);
    currentSrc.pathname = '/' + (typeof languageCode !== 'undefined' ? languageCode : 'de') + '/recommendation/' + typeId;
    iframe.src = currentSrc.toString();
}